import React from 'react';
import { Eye, EyeOff, Lock, Unlock, Sliders, Image as ImageIcon } from 'lucide-react';

/**
 * CalcoControls Component
 * Barra flutuante de controle do "Papel Manteiga / Calco" para fotos reais do ambiente
 */
export const CalcoControls = ({
  hasImage,
  opacity,
  setOpacity,
  isLocked,
  setIsLocked,
  isVisible,
  setIsVisible,
  onUploadClick
}) => {
  if (!hasImage) {
    return (
      <div className="bg-white/90 backdrop-blur-md border border-purple-200 rounded-xl px-3 py-1.5 shadow-md flex items-center gap-2">
        <button
          type="button"
          onClick={onUploadClick}
          className="flex items-center gap-1.5 text-xs font-semibold text-purple-700 hover:text-purple-900 transition-colors"
          title="Inserir foto da parede/ambiente para calcar"
        >
          <ImageIcon className="w-3.5 h-3.5" />
          <span>+ Foto Calco (Ambiente)</span>
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white/95 backdrop-blur-md border border-purple-200 rounded-xl px-3 py-1.5 shadow-md flex items-center gap-3 text-xs">
      <span className="font-bold text-purple-900 flex items-center gap-1">
        🖼️ Calco:
      </span>

      {/* Visibilidade da Foto */}
      <button
        type="button"
        onClick={() => setIsVisible(!isVisible)}
        className={`p-1 rounded hover:bg-gray-100 ${isVisible ? 'text-purple-700' : 'text-gray-400'}`}
        title={isVisible ? 'Ocultar foto' : 'Exibir foto'}
      >
        {isVisible ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
      </button>

      {/* Trava para não arrastar acidentalmente */}
      <button
        type="button"
        onClick={() => setIsLocked(!isLocked)}
        className={`p-1 rounded hover:bg-gray-100 ${isLocked ? 'text-amber-600' : 'text-gray-500'}`}
        title={isLocked ? 'Foto travada (não move)' : 'Foto destravada (ajustar posição)'}
      >
        {isLocked ? <Lock className="w-4 h-4" /> : <Unlock className="w-4 h-4" />}
      </button>

      {/* Slider de Opacidade (Papel Manteiga) */}
      <div className="flex items-center gap-1.5 pl-1 border-l border-gray-200">
        <Sliders className="w-3.5 h-3.5 text-gray-500" />
        <span className="text-[10px] text-gray-500 font-medium">Opacidade:</span>
        <input
          type="range"
          min="0.1"
          max="1.0"
          step="0.05"
          value={opacity}
          onChange={(e) => setOpacity(parseFloat(e.target.value))}
          className="w-16 sm:w-24 h-1.5 bg-purple-100 rounded-lg appearance-none cursor-pointer accent-purple-600"
          title={`Opacidade: ${Math.round(opacity * 100)}%`}
        />
        <span className="text-[10px] font-bold text-purple-800 w-7">
          {Math.round(opacity * 100)}%
        </span>
      </div>

      <button
        type="button"
        onClick={onUploadClick}
        className="text-[11px] text-purple-600 hover:text-purple-800 font-semibold underline pl-1 border-l border-gray-200"
      >
        Trocar Foto
      </button>
    </div>
  );
};

export default CalcoControls;
